import { Component } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { NgIf } from '@angular/common';
import { HeaderComponent, FooterComponent, NavLink, FooterLink } from '@wescot-platform/ui';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgIf, HeaderComponent, FooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class AppComponent {
  /** Controla si se muestran header/footer. false en rutas /a/:id (alarma pública). */
  showShell = true;

  brandName = 'SOSpect';
  contactEmail = 'soporte@wescot.com.co';
  contactPhone = '+00 61 426 037 898';

  contactTitle = 'Contáctenos';
  address = 'Bogotá, Colombia';
  col2Title = 'Enlaces';
  col3Title = 'Legal';

  newsletterTitle = 'Noticias';
  newsletterSubtitle = 'Subscríbete';
  newsletterButton = 'Enviar';
  newsletterPlaceholder = 'Correo';

  navLinks: NavLink[] = [
    { label: 'Inicio', path: '/' },
    { label: 'Acerca de', path: '/about' },
    { label: 'Características', path: '/features' },
    { label: 'Descargas', path: '/downloads' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Políticas', path: '/policies' },
    { label: 'Contáctenos', path: '/contact' },
    { label: 'Blog', path: '/blog' }
  ];

  quickLinks: FooterLink[] = [
    { label: 'Inicio', path: '/' },
    { label: 'Características', path: '/features' },
    { label: 'Descargas', path: '/downloads' }
  ];

  popularLinks: FooterLink[] = [
    { label: 'Política de Privacidad', path: '/policies' },
    { label: 'Términos de Servicio', path: '/policies' }
  ];

  constructor(private router: Router) {
    // Evaluar la URL actual al inicio usando window.location (fuente de verdad absoluta).
    // Esto cubre la carga directa de la página (p.ej. abrir dev.sospect.com/a/1084 desde WhatsApp),
    // donde el NavigationEnd inicial puede emitirse antes de que se cree AppComponent.
    this.showShell = !window.location.pathname.startsWith('/a/');

    // Suscripción para navegaciones SPA posteriores (usuario navega entre rutas)
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      this.showShell = !e.urlAfterRedirects.startsWith('/a/');
    });
  }
}
